<template>
    <div class="image-gallery__large">
        <button class="btn-gallery figure figure--large" @click="handleClick(data.ImageUrl, 0)">
            <img :src="data.ImageUrl" :alt="data.AlternativeText" loading="lazy" />
        </button>
    </div>
</template>

<script setup lang="ts">
import { IGalleryItem } from '../model';
defineProps<{
    data: IGalleryItem;
}>();

const emit = defineEmits<{
    (e: 'onImageClick', image: string, index: number): void;
}>();

function handleClick(image: string, index: number) {
    emit('onImageClick', image, index);
}
</script>
